import { useContext, useEffect, useState } from "react";
import {
  Button,
  ContentTypeRender,
  PanelContext,
  Wrapper,
} from "nystem-components";
import app from "nystem";

const getTargetView = ({ model, view }) => {
  const targetView = {
    view,
    baseView: view.baseView,
    baseViewBaseView: view.baseView?.baseView,
    baseViewBaseViewBaseView: view.baseView?.baseView?.baseView,
  };

  return targetView[model.toView || "view"];
};

const ViewButtonSetValue = ({ model, view, path }) => {
  const { toggleExpand } = useContext(PanelContext) || {};
  const [eventValue, setEventValue] = useState();
  const toView = getTargetView({ model, view });
  const value = toView.getValue(model.field);

  useEffect(() => {
    if (!model.event) return undefined;

    const setEventValueFromEvent = ({ value }) => setEventValue(value);
    view.on(model.event, setEventValueFromEvent);
    return () => {
      view.off(model.event, setEventValueFromEvent);
    };
  }, [model.event, view]);

  let modelValue = model.event
    ? eventValue
    : model.value && model.value.replace(/[0-9]/, "") === ""
      ? parseInt(model.value, 10)
      : app.insertVal(model.value, view, path);

  if (modelValue === "false") modelValue = false;
  if (modelValue === "undefined") modelValue = undefined;

  const disabled =
    model.disabledWhenSame &&
    (!modelValue || `${value || ""}` === `${modelValue || ""}`);

  const setValue = () => {
    if (disabled) return;

    toView.setValue({ path: model.field, value: modelValue });
    if (model.closePanel && toggleExpand) toggleExpand();
  };

  if (model.item?.length)
    return (
      <Wrapper
        className={model.className}
        onClick={() => setValue()}
        renderAs={model.renderAs}
      >
        <ContentTypeRender path={path} items={model.item} />
      </Wrapper>
    );

  return (
    <Button
      type={value === modelValue ? model.btnType : model.falseBtnType}
      size={model.size}
      className={model.className}
      disabled={disabled}
      onClick={() => setValue()}
    >
      {value ? model.text : model.falseText || model.text}
    </Button>
  );
};

export default ViewButtonSetValue;
